import { LOANREQUEST_STATUSES, SUB_STATUS_IN_PROGRESS } from 'cpool-constants';
import { z } from 'zod';

import { commonSchema } from '../common';

export const schemaInProgress = z
    .object({
        status: z.literal(LOANREQUEST_STATUSES.IN_PROGRESS),
        subStatus: z.nativeEnum(SUB_STATUS_IN_PROGRESS).optional(),
    })
    .merge(commonSchema);
